// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader_loader__3R8xD","lds-ring":"loader_lds-ring__FUHRM","active":"loader_active__2glGI"};